import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  Image,
  // Image,
  Modal,
  Rate,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import reviewApi from '../../api/review';
import PageTitle from '../../components/PageTitle';
import IntlMessage from '../../components/IntlMessage';
import FilterBar from '../../components/FilterBar';
import ActionBar from '../../components/ActionBar';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import customersApi from '../../api/customers';
import dayjs from 'dayjs';
import Status from '../../components/Status';
import { ReviewStatus } from '../../utils/constant';
import reportApi from '../../api/report';
import { fillTemplate, formatDateTime } from '../../utils/helpers';
import operatorsApi from '../../api/operators';

const { Text, Paragraph } = Typography;
const { Option } = Select;
const SmsActivity = () => {
  const isMount = useRef(false);
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [condition, setCondition] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const intl = useIntl();
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const items = await reportApi.getAllSmsActivity(filter);
      setItems(items.data);
      setTotal(items.total);
      setLoading(false);
    }

    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObject(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onDelete = async () => {
    await reviewApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onReload = () => {
    setReload((reload) => !reload);
  };
  const [operator, setOperator] = useState([]);
  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        var filter = {
          page: 1,
          limit: 9999,
          keyword: '',
          order_by: 'id',
          order_dir: 'ASC',
        };
        let operator = await operatorsApi.getAll(filter);
        setOperator(operator.data);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const onApprove = async () => {
    const ids = _.filter(selectedRowKeys, (key) => {
      const review = _.find(items, (item) => Number(item.id) === Number(key));
      if (review.approved) return false;
      return true;
    });
    await reviewApi.handleApprove(ids).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const columns = [
    {
      title: <IntlMessage id="global.no" />,
      width: 100,
      render: (text, record, index) => {
        return index + 1 + filter.limit * (filter.page - 1);
      },
    },
    {
      title: <IntlMessage id="global.phone" />,
      render: (text, record, index) => {
        return record?.phone;
      },
    },
    {
      title: <IntlMessage id="global.message" />,
      width: 500,
      render: (text, record, index) => {
        return (
          <Paragraph
            ellipsis={{ rows: 3, expandable: true, symbol: 'Read more' }}>
            {record?.message}
          </Paragraph>
        );
      },
    },
    {
      title: <IntlMessage id="global.provider" />,
      render: (text, record, index) => {
        return record?.provider;
      },
    },
    {
      key: 'created_at',
      title: <IntlMessage id="global.created_at" />,
      render: (record) => (
        <Text>{dayjs(record.createdAt).format('DD/MM/YY HH:mm')}</Text>
      ),
    },
  ];

  const onChangeOperator = (value) => {
    if (value) {
      setFilter({
        ...filter,
        filter_name: ['operator_id'],
        filter_value: [value],
      });
    } else {
      setFilter({ ...filter });
    }
  };

  const [form] = Form.useForm();
  const onSearch = () => {
    form.validateFields().then((values) => {
      setFilter((item) => {
        return {
          ...item,
          from_createdAt: values.from_date,
          to_createdAt: values.to_date,
        };
      });
    });
  };

  return (
    <>
      <Card bordered={false}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Row justify={'space-between'}>
            <Col>
              <PageTitle title={<IntlMessage id="global.smsActivity" />} />
            </Col>
            <Col>
              <ActionBar
                isShowAddButton={false}
                isShowPublishButtons={false}
                isShowCopyButton={false}
                isShowDeleteButton={false}
                onAdd={onOpenModal}
                onRefresh={onReload}
                onDelete={onDelete}
                isDisabled={!(selectedRowKeys.length > 0)}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form layout="inline" form={form} onFinish={onSearch}>
                <Row justify={'start'}>
                  <Col>
                    <Form.Item
                      name="from_date"
                      dependencies={['mode', 'to_date']}
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id="global.requiredfield" />,
                        },
                      ]}>
                      <DatePicker
                        placeholder="Début"
                        format={'DD-MM-YYYY'}
                        picker={'date'}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      name="to_date"
                      dependencies={['mode', 'from_date']}
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id="global.requiredfield" />,
                        },

                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            console.log('value', value);
                            const fromDate = getFieldValue('from_date');

                            // Nếu chưa chọn from_date hoặc chưa chọn to_date → không lỗi
                            if (!value || !fromDate) {
                              return Promise.reject();
                            }

                            // so sánh theo ngày (bỏ phần giờ)
                            const isValid =
                              dayjs(value).isAfter(dayjs(fromDate), 'day') ||
                              dayjs(value).isSame(dayjs(fromDate), 'day');

                            if (isValid) {
                              return Promise.resolve();
                            }

                            // Nếu to_date < from_date → báo lỗi
                            return Promise.reject(
                              new Error(
                                'La date de début doit être antérieure à la date de fin.'
                              )
                            );
                          },
                        }),
                      ]}>
                      <DatePicker
                        placeholder="Fin"
                        format={'DD-MM-YYYY'}
                        picker={'date'}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Chercher
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>

          <Flex vertical gap={8}>
            {/* searchbar */}
            <FilterBar
              onFilter={onFilter}
              playholderSearch="Téléphone"
              data={[
                {
                  name: 'operator_id',
                  data: operator,
                  placeholder: <IntlMessage id="global.operator" />,
                },
                {
                  name: 'provider',
                  data: [
                    { id: 'mtarget', title: 'mtarget', value: 'M Target' },
                    { id: 'orange', title: 'orange', value: 'Orange' },
                  ],
                  placeholder: <IntlMessage id="global.provider" />,
                },
              ]}
            />
          </Flex>

          <Flex justify="center">
            <Card
              style={{
                width: '20%',
                display: 'flex',
                justifyContent: 'center',
              }}>
              <Flex justify="space-between" wrap>
                <Text>
                  <IntlMessage id="global.number_sms" />
                </Text>
              </Flex>
              <Flex justify="center" wrap>
                <Text
                  strong
                  style={{
                    fontSize: '20px',
                  }}>
                  {total}
                </Text>
              </Flex>
            </Card>
          </Flex>

          <Table
            scroll={{ x: 'max-content' }}
            tableLayout="auto"
            columns={columns}
            dataSource={items}
            loading={loading}
            rowSelection={rowSelection}
            rowKey="id"
            size="small"
            onChange={onChangeTable}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              total: total,
              current: filter.page,
              pageSize: filter.limit,
            }}
          />
        </Space>
      </Card>
    </>
  );
};

export default SmsActivity;
